// Initialize map when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    if (typeof mapboxgl === 'undefined') {
        console.error('Mapbox GL JS is not loaded');
        return;
    }

    // Configuration
    const SHOW_POPUP_ON_HOVER = true; // Toggle this to switch between hover and click

    // Set your Mapbox access token
    mapboxgl.accessToken = 'pk.eyJ1IjoibWdjcm9zcy1tYXBib3giLCJhIjoiY203a2lkbGJqMDB3eTJrb2VlY2J1c2V6MCJ9.OnbhoNhQmUhO-hpiGPRbxw'; // This should be set in your WordPress theme

    // Initialize the map
    const map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/light-v11',
        center: [-95.7129, 37.0902], // Default center (US)
        zoom: 5,
        fitBoundsOptions: { padding: { top: 100, bottom: 100, left: 100, right: 100 } }
    });

    // Wait for map to load before adjusting it
    map.on('load', () => {
        if (!mapLocations || !mapLocations.length) {
            console.warn('No locations found');
            return;
        }

        // Create bounds object
        const bounds = new mapboxgl.LngLatBounds();
        let currentPopup = null;
        let isPinned = false;

        // Add markers and extend bounds
        mapLocations.forEach(location => {
            if (!location.lat || !location.long) return;

            // Create popup HTML
            const popupHtml = `
                <div class="map-popup">
                    ${location.image ? `<div class="map-popup-image">
                        <img src="${location.image.url}" alt="${location.name}">
                    </div>` : ''}
                    <div class="map-popup-content">
                        <h3>${location.name}</h3>
                        <p>${location.city}, ${location.state}</p>
                        ${location.website ? `<a href="${location.website.url}" class="visit-website" target="_blank">Visit Website</a>` : ''}
                    </div>
                </div>
            `;

            // Create popup
            const popup = new mapboxgl.Popup({
                offset: 5,
                closeButton: false,
                className: 'custom-popup'
            }).setHTML(popupHtml);

            // Create marker
            const marker = new mapboxgl.Marker({
                element: createCustomMarker(location.status)
            })
                .setLngLat([parseFloat(location.long), parseFloat(location.lat)])
                .addTo(map);

            if (SHOW_POPUP_ON_HOVER) {
                // Add hover events
                marker.getElement().addEventListener('mouseenter', () => {
                    if (!isPinned) {
                        if (currentPopup) {
                            currentPopup.remove();
                        }
                        popup.setLngLat(marker.getLngLat());
                        currentPopup = popup;
                        popup.addTo(map);
                    }
                });

                marker.getElement().addEventListener('mouseleave', () => {
                    if (!isPinned && currentPopup === popup) {
                        popup.remove();
                        currentPopup = null;
                    }
                });

                // Add click to pin/unpin
                marker.getElement().addEventListener('click', (e) => {
                    e.stopPropagation();

                    if (currentPopup === popup && isPinned) {
                        // Unpin and remove popup
                        popup.remove();
                        currentPopup = null;
                        isPinned = false;
                    } else {
                        // Pin this popup
                        if (currentPopup) {
                            currentPopup.remove();
                        }
                        popup.setLngLat(marker.getLngLat());
                        popup.addTo(map);
                        currentPopup = popup;
                        isPinned = true;
                    }
                });
            } else {
                // Use click behavior with toggle
                marker.getElement().addEventListener('click', (e) => {
                    e.stopPropagation();

                    if (currentPopup === popup) {
                        // If this popup is currently shown, remove it
                        popup.remove();
                        currentPopup = null;
                    } else {
                        // If a different popup is shown, remove it first
                        if (currentPopup) {
                            currentPopup.remove();
                        }
                        // Show this popup
                        popup.setLngLat(marker.getLngLat());
                        popup.addTo(map);
                        currentPopup = popup;
                    }
                });
            }

            // Extend bounds to include this point
            console.log("location.long", location.long);
            console.log("location.lat", location.lat);
            bounds.extend([parseFloat(location.long), parseFloat(location.lat)]);
        });

        // Close popup when clicking elsewhere on the map
        map.on('click', () => {
            if (currentPopup) {
                currentPopup.remove();
                currentPopup = null;
                isPinned = false;
            }
        });

        console.log("Initial Bounds:", bounds);

        // Get original bounds coordinates
        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();

        // Calculate padding (adjust this value as needed)
        const padding = 1.5; // Example: 0.5 degrees

        // Adjust latitude for top and bottom padding
        const newNe = new mapboxgl.LngLat(ne.lng, ne.lat + padding);
        const newSw = new mapboxgl.LngLat(sw.lng, sw.lat - padding);
        // const newNe = ne;
        // const newSw = sw;
        // Create new bounds with adjusted coordinates
        const paddedBounds = new mapboxgl.LngLatBounds(newSw, newNe);

        map.fitBounds(paddedBounds, {
            maxZoom: 10
        });


    });
});

// Function to create custom marker element
function createCustomMarker(status) {
    const el = document.createElement('div');
    el.className = 'custom-marker';
    el.style.backgroundImage = `url(${status ? markerGoldUrl : markerUrl})`;
    el.style.width = '23px';
    el.style.height = '31px';
    el.style.backgroundSize = 'cover';
    return el;
} 